<template>
  <div class="w-[280px] h-[240px] flex items-center justify-center relative">
    <component
      :is="iconComponent"
      v-if="iconComponent"
      class="h-full w-full"
      aria-hidden="true"
    />
    <slot v-else />
  </div>
</template>

<script setup lang="ts">
import { computed, type Component } from 'vue';
import { IllustrationVariant } from './state-container.constants';
import Error500Svg from '@/assets/images/errors/500.svg?component';
import Error404Svg from '@/assets/images/errors/404.svg?component';

type Props = {
  illustration?: IllustrationVariant;
};
const props = defineProps<Props>();

const registry: Record<IllustrationVariant, Component> = {
  [IllustrationVariant.HTTP_500]: Error500Svg,
  [IllustrationVariant.HTTP_404]: Error404Svg,
};

const iconComponent = computed<Component | undefined>(() =>
  props.illustration ? registry[props.illustration] : undefined,
);
</script>
